import React from 'react'
import PropTypes from 'prop-types'
import buildURL from '../../utils/buildURL'
import { applicationStateShape } from '../../utils/shapes'
import replaceApplicationStatePlaceholders from '../../utils/replaceApplicationStatePlaceholders'
import verifyParameters from '../../utils/verifyParameters'

class TrackingPixel extends React.Component {
  render() {
    const { type, url, events, applicationState } = this.props
    const { pageType } = applicationState

    // only return a component if window and all required props exists
    /* istanbul ignore if */
    if (typeof window !== 'object' || typeof applicationState !== 'object' || typeof events !== 'object') {
      return null
    }

    const eventTypes = {
      init: true,
      pageview: true,
      landing: pageType === 'landing' || pageType === 'landing_flights',
      index: pageType === 'index',
      search: pageType === 'search_results' || pageType === 'search_results_flights',
      details: pageType === 'product_details',
      checkout: pageType === 'checkout_process',
      success: pageType === 'post_booking',
      others: pageType === 'others',
    }
    const src = {}
    let parameters

    // handle events
    Object.keys(events).forEach((event) => {
      // make sure the event type is valid
      if (eventTypes[event]) {
        const eventUrl = url || events[event].url
        parameters = replaceApplicationStatePlaceholders(events[event].parameters, applicationState)
        // verify that we have values for all parameters
        if (eventUrl && verifyParameters(parameters)) {
          src[event] = buildURL(replaceApplicationStatePlaceholders(eventUrl, applicationState), parameters)
        }
      }
    })

    if (!Object.keys(src).length) {
      return null
    }

    return Object.keys(src).map((key) => {
      switch (type) {
        case 'image':
          return (
            <img
              key={key}
              style={{ position: 'absolute' }}
              src={src[key]}
              alt=''
              data-testid='tracking-pixel'
            />
          )
        case 'iframe':
          return (
            <iframe
              key={key}
              title={key}
              style={{ display: 'none' }}
              width='1'
              height='1'
              frameBorder='0'
              src={src[key]}
              data-testid='tracking-pixel'
            />
          )
        default:
          return null
      }
    })
  }
}

TrackingPixel.propTypes = {
  /**
   * The type of tracking pixel, supports `image` and `iframe`
   */
  type: PropTypes.oneOf(['image', 'iframe']).isRequired,
  /**
   * The url of the pixel. This url will be loaded into an image tag for each event.
   */
  url: PropTypes.string,
  /**
   * An object of events specifying when to load the pixel and what data to pass.
   */
  events: PropTypes.object,
  /**
   * An object of application data that can be used for events.
   */
  applicationState: applicationStateShape,
}

export default TrackingPixel
